import { h, Component, render } from "preact";
import style from "./style";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { constants } from "../../config";
import { getEngagements } from '../../helper';

export default class SocialShareIcons extends Component {
  constructor(props) {
    super(props);
    this.copyTimeout = null;
    this.state = {
      copied: false
    };
  }
  render(props, state) {
    const { tag, size } = props;
    const engagement =
      tag.details && tag.details.engagements && tag.details.engagements[0];
    const layout = props.layout || (engagement && engagement.layout) || 'color';
    const attr = engagement && engagement.attr && JSON.parse(engagement.attr);
    const enabledAttr = attr && attr.filter(item => item.enabled);
    const link = engagement && engagement.link;
    return (
      <ul class={`wt-social-share ${layout} ${size || ""}`}>
        {enabledAttr &&
          enabledAttr.map((icon, idx) => {
            const isCopy = icon.name === "link";
            if (isCopy) {
              return (
                <CopyToClipboard text={link} onCopy={this.onCopyEvent.bind(this, icon.name, link)}>
                  <li key={`icon-${idx}`}>{this.renderIcon(icon.name)}</li>
                </CopyToClipboard>
              );
            }
            return (
              <li
                key={`icon-${idx}`}
                onClick={this.handleShareIconClick.bind(this, icon, link)}
              >
                {this.renderIcon(icon.name)}
              </li>
            );
          })}
      </ul>
    );
  }

  onCopyEvent = (name, link) => {
    this.setState({ copied: true }, () => {
      clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.setState({ copied: false });
      }, 1000);
      this.logEngagementEvent(name); // share specific engagement event---
      this.logEngagementEvent(name, 'engagement');
    });
  };

  handleShareIconClick = (icon, link) => {
    let url = "";
    switch (icon.name) {
      case "facebook":
        url = `https://www.facebook.com/sharer.php?u=${link}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${link}`;
        break;
      case "linkedin":
        url = `https://www.linkedin.com/cws/share?url=${link}`;
        break;
      case "whatsapp":
        url = `https://wa.me/?text=${link}`;
        break;
      case "email":
        url = `mailto:?subject=${"Wootag"}&body=${link}`;
        break;
    }
    if (this.props.onShareIconClick) {
      this.props.onShareIconClick();
    }
    this.logEngagementEvent(icon.name); // share specific engagagement event---
    this.logEngagementEvent(icon.name, 'engagement');
    window.open(url);
  };

  renderIcon = iconName => {
    let iconEle = "";
    switch (iconName) {
      case "facebook":
        iconEle = <i className="zmdi zmdi-facebook" />;
        break;
      case "twitter":
        iconEle = <i className="zmdi zmdi-twitter" />;
        break;
      case "linkedin":
        iconEle = <i className="zmdi zmdi-linkedin" />;
        break;
      case "whatsapp":
        iconEle = <i className="zmdi zmdi-whatsapp" />;
        break;
      case "email":
        iconEle = <i className="zmdi zmdi-email" />;
        break;
      case "link":
        iconEle = this.state.copied ? (
          <div className="wt-share-copy-link">
            <i className="zmdi zmdi-check" />
            {this.props.size === "large" && <span>copied</span>}
          </div>
        ) : (
          <div className="wt-share-copy-link">
            <i className="zmdi zmdi-link" />
            {this.props.size === "large" && <span>copy</span>}
          </div>
        );
        break;
    }
    return (
      <div className={`wt-social-share-icon ${iconName}`}>{iconEle}</div>
    );
  };

  logEngagementEvent = (name, event) => {
    let engagements = getEngagements(this.props.tag);
    let action = engagements && engagements[0];
    let actionValueFormtted = action.slug || "share";

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;

    let options = {
      type: actionValueFormtted,
      sub_type: null,
      event: event || "share_engagement",
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      share_platform: name,
    //   share_link: link,
      current_duration: this.props.getCurrentTime()
    };
    this.props.eventBus(constants.LOG_EVENT_ENGAGEMENT, {
      tag: this.props.tag,
      options
    });
  };
}



// WEBPACK FOOTER //
// ./components/spareparts/socialShareIcons/index.js